<template>
  <div>
    <!-- 更改记录列表 -->
    <el-dialog v-dialogDrag :visible.sync="lookType" width="600px" :close-on-click-modal="false">
      <span slot="title" class="dialog-title">更改记录列表</span>
      <div class="dialogOtherinfo">
        <el-table ref="table11Refs" height="400" :header-cell-style="{ background: '#f3f6f9' }" :cell-style="{ borderRight: 'none' }" border stripe style="width:100%" :data="listArr" tooltip-effect="dark" highlight-current-row>
          <el-table-column prop="createUserName" label="更改人" width="auto" align="center"></el-table-column>
          <el-table-column prop="createTime" label="更新时间" width="auto" align="center"></el-table-column>
        </el-table>
        <div class="card_bottom">
          <div class="card_bottom_left">
            <div class="top_page_totle">总共{{ modifyPage.total }}条</div>
            <el-pagination :current-page.sync="modifyPage.page" :page-size="modifyPage.pageSize" layout="prev, pager, next, jumper" :total="modifyPage.total" @current-change="contractQueryPageContractLogFun()"></el-pagination>
          </div>
          <div>
            <el-button size="mini" icon="el-icon-refresh-right" class="bottom_all_two" @click="contractQueryPageContractLogFun()">刷新</el-button>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button class="bottom_all_two" @click="lookType = false">取 消</el-button>
        <el-button class="bottom_all" style="margin-left: 24px;" @click="handOverPlansaveClientOrderFun()">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import { contractQueryPageContractLog } from "@/api/GHnumber/contract.js";
export default {
  data() {
    return {
      lookType: false,
      listArr: [],
      modifyPage: {
        page: 1,
        pageSize: 10,
        total: 0,
        pid: '',
      },
    };
  },
  methods: {
    contractQueryPageContractLogFun(val) {
      if (val) {
        this.modifyPage.pid = val
      }
      this.lookType = true
      contractQueryPageContractLog(this.modifyPage).then((res) => {
        this.listArr = res.data.data
        this.modifyPage.total = res.data.totalRows
      })
    }
  }
};
</script>